import { HttpClient } from '@angular/common/http';
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppContextService } from '../../services/app-context.service';
import { OperationResult } from '../../models/server-result/operation-result';
import { Observable } from 'rxjs';

import { CodeList } from '../../models/common/code-list';
import { AuditEntryStatusEnum } from './code-list-audit-api.enums';

@Injectable()
export class CodeListAuditApiService {
	constructor(
		private http: HttpClient,
		private appContext: AppContextService,
		private domSanitizer: DomSanitizer
	) {}

	public getCodeListAuditEntryStatus(): Observable<OperationResult<CodeList<AuditEntryStatusEnum>>> {
		return this.http.get<OperationResult<CodeList<AuditEntryStatusEnum>>>(this.domSanitizer.sanitize(SecurityContext.URL, this.appContext.getAuditAPIUrl() + '/codes/status')!);
	}
}
